(function($){

	$(document).ready(function(){

		$(document).on('click','.staff-members__wrapper .see-more__link',function(e){
			e.preventDefault();
			$event_elements = $(this).closest('.staff-members__wrapper').find('.staff');
			$visible_elements = $(this).closest('.staff-members__wrapper').find('.staff:visible').size();
			$hidden_elements = $(this).closest('.staff-members__wrapper').find('.staff:hidden').size(); 

			if($hidden_elements) {

				$elements_to_show = $visible_elements + 3;
				$(this).closest('.staff-members__wrapper').find('.staff:lt(' + $elements_to_show + ')').show();

				if($(this).closest('.staff-members__wrapper').find('.staff:hidden').size() == 0) {
					$(this).parent().hide();
				}
			}
		});

	});
	
})(jQuery);